export default "__VITE_ASSET__D645xOfR__"